<template>
<v-app>
    <v-container fill-height>
        <v-row justify='center'>
            <v-col cols="10">
                <v-sheet>
                    <v-card id="rounded-card" height="100%" :elevation="elevation">
                        <v-row justify="center">
                            <v-img contain style="padding-top:40px" height="200px" width="100%" :src="require('../assets/12.png')" /><br />
                        </v-row>
                        <v-layout justify="center">
                            <v-flex xs10 md10 offset-xs1 style="padding-top:2%">

                                <h2 style="text-align:center">สร้างบัญชีผู้ใช้ใหม่</h2>
                                <v-text-field style="padding-top:3% ; border-radius:10px" v-model="username" label="ชื่อผู้ใช้" required outlined dense></v-text-field>
                                <v-text-field v-model="password" style="border-radius:10px" hide-details :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showpassword ? 'text' : 'password'" label="รหัสผ่าน" required @click:append="showpassword = !showpassword" outlined dense></v-text-field>
                                <v-text-field v-model="password" style="border-radius:10px; padding-top:3%" hide-details :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showpassword ? 'text' : 'password'" label="ยืนยันรหัสผ่าน" required @click:append="showpassword = !showpassword" outlined dense></v-text-field>
                                <v-text-field style="padding-top:3% ; border-radius:10px" v-model="email" label="อีเมล" required outlined dense></v-text-field>

                                <div class="text-center" style="padding-bottom:2%">
                                    <v-btn class="box" width="50%" rounded dark dense style="height:45px; font-size:20px" @click="$router.push('/Home')">
                                        สร้างบัญชี
                                    </v-btn>
                                </div>

                            </v-flex>
                        </v-layout>

                    </v-card>
                </v-sheet>
            </v-col>
        </v-row>

    </v-container>
</v-app>
</template>

    
<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'
export default {
    data: () => ({
        username: null,
        password: null,
        email: null,
        elevation: 2,
        showpassword: false,
        checkbox: false,
        zIndex: 0,
        opacity: 0.9,
    }),
    methods: {

        // login() {
        //     console.log(this.username)
        //     console.log(this.password)
        //     let payload = {
        //         'username': this.username,
        //         'password': this.password
        //     }

        //     this.$store.dispatch("datas/login", payload)

        //     if (this.$store.state.datas.data.login_status = 1) {
        //         this.$router.push({
        //             name: 'Home'
        //         });
        //     }

        //     this.username = null
        //     this.password = null

        // },
        // keymonitor: function (event) {
        //     console.log(event.key);
        //     if (event.key == "Enter") {
        //         console.log("enter key was pressed!");
        //         this.login()
        //     }
        // },
    },

    computed: {
        ...mapState('datas', {
            data: 'data'
        }),
        // formlogin() {
        //     return (
        //         this.username &&
        //         this.password
        //     )
        // },
        // token() {
        //     return this.$store.state.users.user.token
        // }
    },

    watch: {
        token() {
            this.$router.push({
                name: 'Home'
            });

        }
    },

}
</script>

    
<style>
.v-card--reveal {
    bottom: 0;
    opacity: 1 !important;
    position: absolute;
    width: 100%;

}

#rounded-card {
    /* border-radius: 20px; */
    -webkit-box-shadow: 0 20px 50px rgba(0, 0, 0, .2);
    box-shadow: 0 -1px 10px rgba(0, 0, 0, .2) !important;
    padding-left: 3%;
    padding-right: 3%;
    padding-top: 2%;
    padding-bottom: 2%;
}

.box {
    background: rgb(25, 40, 172);
    background: linear-gradient(0deg, rgba(25, 40, 172, 1) 20%, rgba(167, 161, 161, 1) 100%);
}
</style>
